function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
export function SuccessfulAdoptions({
  width = 31,
  height = 28,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: width,
    height: height,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    clipRule: "evenodd",
    d: "M2.188 13.12C.623 8.42 2.452 3.046 7.581 1.456c2.698-.837 5.676-.343 7.919 1.28 2.122-1.578 5.209-2.112 7.904-1.28 5.129 1.59 6.97 6.963 5.406 11.664-2.435 7.451-13.31 13.19-13.31 13.19S4.705 20.658 2.188 13.12z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M21.333 6.246c1.56.486 2.663 1.826 2.796 3.399",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
//# sourceMappingURL=SuccessfulAdoptions.js.map